export const userStatus = Object.freeze({
  PENDING: 'Pendiente',
  ACTIVE: 'Activo'
})
